'use strict'

module.exports = normalize

function normalize(value) {
  return value.toLowerCase().replace(/\b[:-]\b/g, '')
}



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/normalize.js
// module id = 112
// module chunks = 33019919093843 87034247430840 144482056661899